module.exports = __webpack_public_path__ + "img/cg2.01315748.png";